import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Cookies from "universal-cookie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import "./IosInstallBanner.css";

const DISMISSED_KEY = "ios_install_banner_dismissed_at";
const TWO_WEEKS_MS = 14 * 24 * 60 * 60 * 1000;

const isIosSafari = () => {
  const ua = window.navigator.userAgent;
  const isIos = /iphone|ipad|ipod/i.test(ua);
  // Chrome on iOS reports CriOS, Firefox reports FxiOS — exclude those
  const isSafariBased = /safari/i.test(ua) && !/crios|fxios/i.test(ua);
  return isIos && isSafariBased;
};

const isInStandaloneMode = () => window.navigator.standalone === true;

const IosInstallBanner = ({ primaryColor }) => {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation(["ios_install"]);

  useEffect(() => {
    if (!isIosSafari() || isInStandaloneMode()) return;

    const cookies = new Cookies();
    const showIfDue = () => {
      const dismissedAt = localStorage.getItem(DISMISSED_KEY);
      const expired = !dismissedAt || Date.now() - Number(dismissedAt) > TWO_WEEKS_MS;
      if (expired) setVisible(true);
    };

    if (cookies.get("CookieConsent") !== undefined) {
      showIfDue();
      return;
    }

    const interval = setInterval(() => {
      if (cookies.get("CookieConsent") !== undefined) {
        clearInterval(interval);
        showIfDue();
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISSED_KEY, String(Date.now()));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="ios-install-banner" style={{ borderColor: primaryColor }}>
      <div className="ios-install-banner__content">
        <img
          src="/logo256.png"
          alt="Health Profile"
          className="ios-install-banner__icon"
        />
        <div className="ios-install-banner__text">
          <p className="ios-install-banner__title">{t("title")}</p>
          <p className="ios-install-banner__desc">
            {t("description_intro")}
            <strong>{t("share_label")}</strong>
            <span className="ios-install-banner__share-icon" aria-label="share">
              {/* iOS share icon using unicode box-arrow */}⬆
            </span>
            {t("description_middle")}
            <strong>{t("add_to_home_label")}</strong>
            {t("description_end")}
          </p>
        </div>
      </div>
      <button
        className="ios-install-banner__close"
        onClick={dismiss}
        style={{ color: primaryColor }}
        aria-label="close"
      >
        <FontAwesomeIcon icon={faXmark} />
      </button>
    </div>
  );
};

export default IosInstallBanner;
